import React from 'react';
import { ListItem, Toggle, Chip, Avatar, FontIcon, Card, CardHeader, CardText } from 'material-ui';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import SingleAllocationNode from '../../contract-activities-products/add-edit-dialog-content/allocation/single-allocation-node';
import R from 'ramda';
import AskIfVaryBySeason from '../../generic-components/seasonal-sections/ask-if-vary-by-season.jsx';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const propTypes = {
  templateSelected: React.PropTypes.object,
  templateGroupSelected: React.PropTypes.object,
  partners: React.PropTypes.array,
  productIdNameMap: React.PropTypes.object,
  updateSendToPartnerReducer: React.PropTypes.func,
  showAllocationError: React.PropTypes.bool,
};
class AddAllotments extends React.Component {
  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps));
  }
  render() {
    const { partners, productIdNameMap, updateSendToPartnerReducer, templateSelected, templateGroupSelected, showAllocationError } = this.props;
    const templates = isNilOrEmpty(templateSelected) ? templateGroupSelected.templates : [templateSelected];
    return (
      <div>
        {
          partners.map((partner, partnerIndex) => {
            return (
              <Card key={partnerIndex} expandable style={{ boxShadow: 'none' }} initiallyExpanded={false}>
                <CardHeader
                  actAsExpander
                  showExpandableButton
                  style={{ borderBottom: '1px solid #e0e0e0' }}
                  title={<Chip>
                    { partner.profileImageUrl ?
                      <Avatar src={partner.profileImageUrl}/>
                      : <Avatar>{R.head(partner.email && partner.email !== 'via TourConnect' ? partner.email : partner.company_name)}</Avatar> }
                    {partner.company_name || partner.companyName || partner.email}
                  </Chip>}
                />
                <CardText expandable>
                  {
                    (partner.templates || templates).map((template, templateIndex) => {
                      return (
                        <div key={templateIndex} style={{ paddingLeft: '5%' }}>
                          <div style={{ fontSize: '16px', lineHeight: '32px' }}><FontIcon className="tc-icon-location_on" color="rgba(0, 0, 0, 0.54)" />{template.locationName}</div>
                          {
                            template.products.map((product, productIndex) => {
                              const { productId, customizedAllocation, includeSpecialAllocation, varyBySeason, seasons, seasonRates } = product;
                              const seasonNames = R.pluck('seasonName', isNilOrEmpty(seasons) ? seasonRates : seasons);
                              return (
                                <div key={productIndex} style={{ paddingLeft: '5%' }}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    {productIdNameMap[productId]}
                                    <Toggle
                                      toggled={Boolean(includeSpecialAllocation)}
                                      label="Include Special Allocation"
                                      style={{ width: '240px' }}
                                      labelPosition="right"
                                      onToggle={(_, newVal) => {
                                        const updatedImmutableProd = fromJS(product).merge({
                                          includeSpecialAllocation: newVal,
                                          varyBySeason: newVal ? varyBySeason : undefined,
                                          customizedAllocation: newVal ? customizedAllocation : undefined,
                                        });
                                        // why if blocks: only the first time toggle need to update templates in the reducer, less updates better experience
                                        if (!partner.templates) {
                                          const updatedImmutablePartner = fromJS(partner)
                                            .merge(fromJS({ templates: partner.templates || templates }))
                                            .setIn(['templates', templateIndex, 'products', productIndex], updatedImmutableProd);
                                          updateSendToPartnerReducer({
                                            keyPath: ['partnersToSendTo', partnerIndex],
                                            immutableValue: updatedImmutablePartner,
                                          });
                                        } else {
                                          updateSendToPartnerReducer({
                                            keyPath: ['partnersToSendTo', partnerIndex, 'templates', templateIndex, 'products', productIndex],
                                            immutableValue: updatedImmutableProd,
                                          });
                                        }
                                      }}
                                    />
                                  </div>
                                  {
                                    includeSpecialAllocation ? (<div style={{ paddingBottom: '24px' }}>
                                      <AskIfVaryBySeason
                                        name="Allocation"
                                        enableManualDatesEntry={false}
                                        varyBySeason={varyBySeason}
                                        useSeasons={false}
                                        selectIfVaryBySeason={(newVal) => {
                                          const singleEmptyAllo = { allocationType: 'allotment', allotments: [{}] };
                                          const newAllo = newVal ? seasonNames.map(R.always(singleEmptyAllo)) : [singleEmptyAllo];
                                          const immutableProduct = fromJS(product).merge(fromJS({
                                            varyBySeason: newVal,
                                            customizedAllocation: newVal !== varyBySeason ? newAllo : customizedAllocation,
                                          }));
                                          updateSendToPartnerReducer({
                                            keyPath: ['partnersToSendTo', partnerIndex, 'templates', templateIndex, 'products', productIndex],
                                            immutableValue: immutableProduct,
                                          });
                                        }}
                                      />
                                      {
                                        customizedAllocation ? customizedAllocation.map(({ allocationType, allotments, releaseBackDays }, allocationIndex) => {
                                          const path = ['partnersToSendTo', partnerIndex, 'templates', templateIndex, 'products', productIndex, 'customizedAllocation'];
                                          return (
                                            <div key={allocationIndex} style={{ padding: '0 0 4px 2%', margin: '8px 5%', display: 'flex', justifyContent: 'space-between', border: '3px solid #e0e0e0' }}>
                                              <div style={{ width: '30%', paddingTop: '12px' }} >{varyBySeason ? seasonNames[allocationIndex] : 'All Year'}</div>
                                              <div style={{ width: '65%' }}>
                                                <SingleAllocationNode
                                                  index={allocationIndex}
                                                  style={{ width: '100%', margin: 0 }}
                                                  showError={showAllocationError}
                                                  allocationType={allocationType}
                                                  allotments={allotments}
                                                  releaseBackDays={releaseBackDays}
                                                  onTextFieldChangeWithKeyPath={({ keyPath, value }) => updateSendToPartnerReducer({
                                                    keyPath: R.concat(path, keyPath),
                                                    immutableValue: R.is(Object, value) ? fromJS(value) : value,
                                                  })}
                                                  addOneElementWithKeyPath={() => updateSendToPartnerReducer({
                                                    keyPath: R.concat(path, [allocationIndex, 'allotments']),
                                                    immutableValue: fromJS(R.append({}, allotments)),
                                                  })}
                                                  deleteOneElementWithKeyPath={({ keyPath }) => updateSendToPartnerReducer({
                                                    keyPath: R.concat(path, [allocationIndex, 'allotments']),
                                                    immutableValue: fromJS(R.remove(R.last(keyPath), 1, allotments)),
                                                  })}
                                                />
                                              </div>
                                            </div>
                                          );
                                        }) : <span/>
                                      }
                                    </div>) : <span/>
                                  }
                                </div>
                              );
                            })
                          }
                        </div>
                      );
                    })
                  }
                </CardText>
              </Card>
            );
          })
        }
      </div>
    );
  }
}
AddAllotments.propTypes = propTypes;
const mapStateToProps = ({ contracting }) => ({
  partners: contracting.sendToPartners.get('partnersToSendTo').toJS(),
  productIdNameMap: contracting.supplierWizard.get('productIdNameMap').toJS(),
});
const mapDispatchToActions = dispatch => ({
  updateSendToPartnerReducer: payload => dispatch({ type: 'UPDATE_CONTRACTING_SEND_TO_PARNTNERS_WITH_KEYPATH', payload }),
});
export default connect(mapStateToProps, mapDispatchToActions)(AddAllotments);



// WEBPACK FOOTER //
// ./src/app/components/contracting/supplier-wizard/supplier-initiated/add-allotments.jsx